import { useCallback } from 'react';

import { observer } from 'mobx-react';

import { useLocale } from '../../../../hooks/useLocale';
import { logToNewRelic } from '../../../../services/debug';
import { EnumOpenDialog } from '../../../../stores/ui/types';
import { useStores } from '../../../../stores/useStores';
import { getErrorMessage } from '../../../../utils/errors';
import QuestTimer from '../elements/QuestTimer';

const QuestWidget = observer(() => {
  const { questStore, uiStore } = useStores();
  const { currentPlayerQuest } = questStore;

  const { locale } = useLocale();

  const handleWidgetClick = () => {
    try {
      questStore.sendAnalyticsEvent({
        event_action: 'impression',
        params: {
          triggered_by: 'click',
          click_location: 'widget',
        },
      });

      void questStore.refreshMilestoneProgress();
      uiStore.setOpenDialog({ dialog: EnumOpenDialog.isOpenQuestDialog });
    } catch (e) {
      const errorMessage = getErrorMessage(e);
      logToNewRelic('Quest widget click error', errorMessage, 'error');
    }
  };

  const handleQuestTimerEnd = useCallback(() => {
    const randomDelayMS = (Math.floor(Math.random() * (5 - 1 + 1)) + 1) * 1000;

    setTimeout(() => {
      void questStore.fetch();
    }, randomDelayMS);
  }, [questStore]);

  if (!currentPlayerQuest) {
    return null;
  }

  const { widgetImageUrl, layout } = currentPlayerQuest;

  const localizedElement = layout.localizedElements?.[locale] || layout.localizedElements?.EN;

  const displayWidgetImageUrl = localizedElement?.miniImageUrl || widgetImageUrl;

  return (
    <div className="home-widget" data-testid="quest-widget">
      <div className="circle-parent" data-testid="quest-widget-button" onClick={handleWidgetClick}>
        <div className="circle" />
        <img alt="Event Mini Image" src={displayWidgetImageUrl} />
        {!currentPlayerQuest.hideTimer && <QuestTimer onEnd={handleQuestTimerEnd} />}
      </div>
    </div>
  );
});

export default QuestWidget;
